import {
  APPWRITE_DB_ID,
  APPWRITE_SUBSCRIPTIONS_COLLECTION_ID,
} from "../AppWrite/appwrite";
import conf from "../conf/conf";
import { Client, Databases } from "appwrite";

const client = new Client()
  .setEndpoint(conf.appwrite_url)
  .setProject(conf.appwrite_project_id);

const databases = new Databases(client);

// ✅ Create subscription document
export const fetchSubscribe = async (subscriptionData) => {
  try {
    const response = await databases.createDocument(
      APPWRITE_DB_ID,
      APPWRITE_SUBSCRIPTIONS_COLLECTION_ID,
      "unique()", // auto-generate ID
      {
        Email: subscriptionData.Email,
        subscribed: true, // always true
      }
    );

    return { success: true, data: response };
  } catch (e) {
    console.error("Error during subscription:", e);
    return {
      success: false,
      message: e?.message || "Subscription failed",
    };
  }
};
